import React from "react";
import { applicationLogoV2 } from "@tvet-mis/psda-assets";
import { OptimizedSvg } from "../common/OptimizedSvg";

const SidebarLogo: React.FC = () => (
	<div className="p-4 mb-6 flex justify-center">
		<OptimizedSvg
			width="8rem"
			height="auto"
			src={applicationLogoV2}
			alt="Portal Logo"
			className="sidebar-logo"
			cacheKey="portal-logo-v2"
		/>
	</div>
);

export default SidebarLogo;
